import { TCommonData, TLayout, TWidgetProps } from '@libs/types';
import { CoreLayoutView, ORIENTATION_ENUM, TCoreLayoutStyleProps } from '@core/widgets';
import React from 'react';
import { THorizontalLayoutOption } from '../../types/options';

const toLine = (value?: string): TCoreLayoutStyleProps['lineX'] => (value ? (value.replace(/-/g, '_') as TCoreLayoutStyleProps['lineX']) : undefined);

export const HorizontalLayout: React.FC<TWidgetProps<TCommonData, THorizontalLayoutOption> & TLayout> = ({ widget, children, margin }) => {
    const alignment = widget.options?.alignment ?? 'start';
    const arrangement = widget.options?.arrangement ?? 'center';

    const styleProps: TCoreLayoutStyleProps = {
        orientation: ORIENTATION_ENUM.HORIZONTAL,
        lineX: toLine(arrangement),
        lineY: alignment as TCoreLayoutStyleProps['lineY'],
        margin,
    };

    return (
        <CoreLayoutView uid={widget.uid} styleProps={styleProps} isHide={widget.options?.isHide} styleName={widget.options?.style}>
            {children}
        </CoreLayoutView>
    );
};
